import Accessories from "../constants/Accessories";
import { Purchases } from "../constants/Purchases";
import { IProduct, ITpackage } from "../entities/product/types";
import Validator from "./Validator";

export default class ProductValidator extends Validator  {

  public static validateTpPrices(tariffPackage:ITpackage, purchase: string): boolean {
    if (!this.isUndefined(tariffPackage.prices) &&
      this.isObject(tariffPackage.prices) &&
      this.checkIfObjectHasPropKeys(tariffPackage.prices) &&
      this.validatePrices(tariffPackage.prices, purchase)
    ) {
      return true;
    }

    return false;
  }

  private static validatePrices(prices: any, purchase: string) {
    if (!this.isUndefined(prices[purchase]) &&
      this.isArray(prices[purchase]) &&
      this.checkIfArrayHasItems(prices[purchase])
    ) {
      return true;
    }

    return false;
  }

  private static validateTp(product: IProduct) {
    if (this.isUndefined(product.tariffPackages) &&
      !this.isArray(product.tariffPackages) &&
      !this.checkIfArrayHasItems(product.tariffPackages)
    ) {
      return false;
    }

    if (!this.validateCosmosTpPrices(product)) {
      return false;
    }

    if (!this.validateSubsidyTpPrices(product)) {
      return false;
    }

    return true;
  }

  private static validateCosmosTpPrices(product: IProduct) {
    if (product.sellCosmos &&
      typeof product.tariffPackages.find((tPackage) => this.validateTpPrices(tPackage, Purchases.COSMOS)) === 'undefined') {
      return false;
    }

    return true;
  }

  private static validateSubsidyTpPrices(product: IProduct) {
    if (product.sellSubsidy &&
      typeof product.tariffPackages.find((tPackage) => this.validateTpPrices(tPackage, Purchases.SUBSIDY)) === 'undefined') {
      return false;
    }
    return true;
  }

  private static validateProductPricesByPurchase(productPrices: any, purchase: string) {
    if (this.isUndefined(productPrices[purchase]) &&
      !this.isArray(productPrices[purchase]) &&
      !this.checkIfArrayHasItems(productPrices[purchase]
      )) {
      return false;
    }

    return true;
  }

  private static validateProductPrices(product: IProduct) {
    if (product.sellCosmos && this.validateProductPricesByPurchase(product.productPrices, Purchases.COSMOS)) {
      return true;
    }

    if (product.sellSubsidy && this.validateProductPricesByPurchase(product.productPrices, Purchases.SUBSIDY)) {
      return true;
    }

    if (product.sellWithoutContractObligation && this.validateProductPricesByPurchase(product.productPrices, Purchases.SUBSIDY)) {
      return true;
    }

    return false;
  }

  public static validate(product: IProduct) {
    if (!Accessories.includes(product?.productLine?.productLine)) {
      if (!this.validateTp(product)) {
        return false;
      }

      return true;
    }

    if (!this.validateProductPrices(product)) {
      return false;
    }

    return true;
  }

}
